<template>
	<a
		:href="data.link"
		class="card card--no-gutter news-list-item list-item hearing-list__item"
		:class="{ 'list-item--mounted': isMounted }"
	>
		<div class="hearing-list__item-content">
			<div class="hearing-list__item-pre hearing-list__item-label">
				{{ dataLabels.hearinglabel }} {{ data.hearingLocalPlan }}
			</div>
			<h2 class="header-extra-small">
				{{ data.title }}
			</h2>
			<div class="hearing-list__item-description body-text">
				{{ data.description }}
			</div>
			<div class="hearing-list__item-pre hearing-list__item-deadline">
				<span class="hearing-list__item-label">
					{{ dataLabels.deadlinelabel }}:
				</span>
				<span>{{ formatDate(data.hearingDeadline) }}</span>
			</div>
			<span class="hearing-list__item-icon" v-html="IconArrow"></span>
		</div>
	</a>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import IconArrow from "../../../../views/icons/arrow.cshtml";

const props = defineProps(['data', 'dataLabels']);
const isMounted = ref(false);

onMounted(() => {
	setTimeout(() => {
		isMounted.value = true;
	}, 10);
});

const formatDate = (date) => {
	return utilities.formatDate(date);
};
</script>
